module.exports = __webpack_public_path__ + "img/owl@4x-246x300.1c6a4047.png";